import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'
import type { FileRef } from '@/shared/lib'

// Новая версия документа (+ заметка). Согласование сбрасывается на бэке.
// Инвалидация — весь namespace документов (detail + versions + листинг владельца).
export function useAddVersion(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (vars: { file: FileRef; note?: string }) =>
      apiRequest({ method: 'POST', url: `/documents/${documentId}/versions`, body: vars }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['document'] })
    },
  })
}
